import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../components/mensajes";

import {
  validaSoloNumero,
  formatMoneda,
  validaMonto,
  formatoMonto,
} from "../util/varios";
import TablaDeudaComercio from "../components/hacienda/actividadEconomica/tablaDeudaComercios";
import TablaPagosComercio from "../components/hacienda/actividadEconomica/tablaPagosComercios";
import TablaFacturasContribuyente from "../components/hacienda/actividadEconomica/tablaFacturasContribuyentes";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import TablaDeudasEjidos from "../components/hacienda/rentaInmobiliaria/tablaDeudaEjidos";
import TablaHistoricosEjidos from "../components/hacienda/rentaInmobiliaria/tabaHistoricoEjidos";
import useTable from "../components/useTable";
import { TableBody, TableRow, TableCell, Fab } from "@mui/material";
import axios from "axios";
import { Dimmer } from "../components/spinner";

export const CatalagoVehiculo = (props) => {
  /*  variables de estados */

  let op = require("../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [mostrar5, setMostrar5] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  const [titulo2, setTitulo2] = useState();
  const [msg2, setMsg2] = useState();
  const [contar1, setContar1] = useState(0);
  const [activate, setActivate] = useState(false);
  const [permiso, setPermiso] = useState();
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [mostrar, setMostrar] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [tabIndex, setTabIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [idUsuario, setIdUsuario] = useState();
  const [declaWeb, setDeclaWeb] = useState();
  const txtIdComercio = useRef();
  const txtRitm = useRef();
  const txtNumPatente = useRef();
  const txtDenominacionCome = useRef();
  const [values, setValues] = useState({});
  const [itemSelect, setItemSelect] = useState(-1);
  const [activo, setActivo] = useState(true);

  const cmbStatus = useRef();

  const [anio, setAnio] = useState([]);

  const headCells = [
    {
      id: "",
      label: "PLACA",
      width: "80px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "",
      label: "RITM",
      width: "110px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "",
      label: "NOMBRE PROPIETARIO",
      width: "300px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "",
      label: "CODIGO VEHICULO",
      width: "80px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch1 = (e) => {
    let target = e.target;
    if ((target.name = "Search")) {
      target.value = target.value.toUpperCase();

      setFilterFn({
        fn: (items) => {
          if (target.value === "") {
            return items;
          } else {
            return items.filter((x) => {
              if (
                x.idvehiculo.includes(target.value) ||
                x.nombrepropie
                  .toLowerCase()
                  .includes(target.value.toLowerCase()) ||
                x.placa.toLowerCase().includes(target.value.toLowerCase()) ||
                x.ritm.toLowerCase().includes(target.value.toLowerCase())
              ) {
                return x;
              }
            });
          }
        },
      });
    }
  };

  const seleccionarRegistrosVehiculos = () => {
    let campos = "*";
    let nomtab = "vehiculo";
    let orden = "idvehiculo desc";

    let endpoint =
      op.conexion +
      `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          console.log(response.data);
          setRecords(response.data);
        }

        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };

  const seleccionarLista = (index) => (event) => {
    salir();

    blanquear();
    if (props.caja) {
      props.onHideAceptaCatCom(values[0]);
    } else {
      props.onHideAceptaCatCom(
        values[0].idvehi,
        values[0].nombre,
        values[0].ritm,
        values[0].placa,
        values[0].direccion
      );
    }
  };

  const blanquear = () => {
    setTitulo("");
    setMsg("");
    setActivate(false);
    setRecords([]);
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
  };

  const handleCloseSi = () => {
    setMostrar1(false);
  };

  const handleCloseNo = () => {
    setMostrar1(false);
  };

  const abrirmodal = () => {
    setMostrar5(true);
  };

  const cerrarModalActualizar = () => {
    setMostrar5(false);
  };

  const salir = () => {
    props.onHideCancela();
  };

  const seleccionarFila = (index) => (event) => {
    var datos = [];
    setItemSelect(index);
    setActivo(false);
    var idvehi = recordsAfterPagingAndSorting()[index].idvehiculo;
    var nombre = recordsAfterPagingAndSorting()[index].nombrepropie;
    var placa = recordsAfterPagingAndSorting()[index].placa;
    var ritm = recordsAfterPagingAndSorting()[index].ritm;
    const direccion = recordsAfterPagingAndSorting()[index].direccionpropie;
    var datos = [];

    datos.push({
      idvehi,
      nombre,
      placa,
      ritm,
      direccion
    });
    setValues(datos);
  };

  useEffect(() => {}, []);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarRegistrosVehiculos();
      }}
    >
      <Modal.Header className="azulGradiant">
        <Modal.Title style={{ color: "#fff" }}>
          Seleccionar Vehiculo
        </Modal.Title>
        <button
          ref={btnCancela}
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={salir}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ color: "rgb(106, 115, 123)" }}>
        <Dimmer active={activate} inverted></Dimmer>
        <div style={{ overflow: "auto" }}>
          <div className="card-body">
            <div className="content">
              <div className="container">
                <div className="row">
                  <div className="col-md-12" style={{ marginBottom: "10px" }}>
                    <div className="row">
                      <div className="col-md-12 m-0">
                        <div className="input-group input-group-sm mb-3 m-0 col-md-5">
                          <input
                            type="text"
                            onChange={handleSearch1}
                            className="form-control rounded-pill"
                          />
                        </div>
                      </div>
                      <div
                        className="col-md-12"
                        style={{ margin: "auto", marginTop: "2%" }}
                      >
                        <TblContainer>
                          <TblHead />

                          <tbody>
                            {records &&
                              recordsAfterPagingAndSorting().map(
                                (item, index) => (
                                  <tr
                                    key={item.idinmueble}
                                    style={{
                                      padding: "0",
                                      cursor: "pointer",
                                      background:
                                        itemSelect === index
                                          ? "lightskyblue"
                                          : "white",
                                    }}
                                    onClick={seleccionarFila(index)}
                                  >
                                    <td
                                      style={{
                                        fontSize: "10px",
                                        textAlign: "center",
                                      }}
                                    >
                                      {item.placa}
                                    </td>
                                    <td
                                      style={{
                                        fontSize: "10px",
                                        textAlign: "center",
                                      }}
                                    >
                                      {item.ritm}
                                    </td>
                                    <td
                                      style={{
                                        fontSize: "10px",
                                        textAlign: "center",
                                      }}
                                    >
                                      {item.nombrepropie}
                                    </td>
                                    <td
                                      style={{
                                        fontSize: "10px",
                                        textAlign: "center",
                                      }}
                                    >
                                      {item.idvehiculo}
                                    </td>
                                    {/*    <td style={{ fontSize: "10px", textAlign: "center", border: "rgb(14, 101, 238) 1px solid", padding: 0 }}>
                                                                            <button style={{ fontSize: '10px' }} onClick={seleccionasrInmueble(index)} className="btn btn-outline-info"><i className="fas fa-search">Seleccionar</i> </button>

                                                                        </td> */}
                                  </tr>
                                ),
                              )}
                          </tbody>
                        </TblContainer>
                        <TblPagination />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill"
          disabled={activo}
          style={{ margin: "5px" }}
          onClick={seleccionarLista()}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>

        <button
          ref={btnCancela}
          onClick={salir}
          className="btn btn-sm rounded-pill btn-danger col-md-2"
        >
          <i className="fas fa-window-close">Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CatalagoVehiculo;
